import type { JSX } from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ANY_FILTER_VALUE } from '@/shared/utils/tableFilters';

export interface FilterSelectOption {
  value: string;
  label: string;
}

export interface FilterSelectProps {
  id: string;
  label: string;
  value: string | undefined;
  options: FilterSelectOption[];
  onChange: (value: string | undefined) => void;
}

/** Select whose "any" option resets the filter instead of storing a value. */
export function FilterSelect({
  id,
  label,
  value,
  options,
  onChange,
}: FilterSelectProps): JSX.Element {
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Select
        value={value ?? ANY_FILTER_VALUE}
        onValueChange={(next) => onChange(next === ANY_FILTER_VALUE ? undefined : next)}
      >
        <SelectTrigger id={id} aria-label={`Filter by ${label}`} className="w-full sm:w-[180px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
